const SEVEN_DAYS_TO_MILLISECONDS = 7 * 24 * 60 * 60 * 1000

export function isPlanOlderThan7Days(createdAtUtc: string | null) {
  return createdAtUtc != null && Date.now() - Date.parse(createdAtUtc) > SEVEN_DAYS_TO_MILLISECONDS
}
